/* eslint-disable eqeqeq */
import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import randomstring from 'randomstring';
import ModalImage from 'react-modal-image';
import Compressor from 'compressorjs';
import { Link } from 'react-router-dom';
import Loading from './Loading';

// import ImageCropper from './ImageCropper';

import useImageUploading from '../../hooks/useImageUploading';

const Wrapper = styled.figure`
  position: relative;
  padding-top: 15% !important;
  width: 50%;
  img {
    border-radius: 10px;
    height: 100%;
    object-fit: cover;
  }
  .file-wrapper {
    display: flex;
    align-items: center;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    border: 1px solid ${(props) => props.theme.borderColor};
    background-color: ${(props) => props.theme.secondaryColor};
    .file-input {
      cursor: pointer;
    }
    .icon {
      height: 100%;
      font-size: 24px;
    }
  }
  &.circle {
    img {
      border-radius: 50%;
    }
    .file-wrapper {
      border-radius: 50%;
    }
  }
  .loading {
    height: 100%;
    display: flex;
    align-items: center;
  }
`;

const ModalBoxWrapper = styled.div`
  border: 1px solid ${(props) => props.theme.borderColor};
  figure {
    border: 1px solid ${(props) => props.theme.borderColor};
  }
`;

const SvgIcon = styled.svg`
  width: 70px;
  height: 70px;
  @media only screen and (max-width: 768px) {
    width: 20px;
    height: 20px;
  }
`;

const UploadImageInput = ({ value, values, onChange, placeholder }) => {
  const [uploadedUrls, setUploadedUrls] = useState(value || []);

  const [isPdf, seIsPdf] = useState(false);

  const [uploadedFileUrl, isUploading, { setFile, setFileName, setFileType }] =
    useImageUploading();

  useEffect(() => {
    if (uploadedFileUrl) {
      onChange(uploadedFileUrl);
      setUploadedUrls((oldUrl) => [...oldUrl, uploadedFileUrl]);
    }
  }, [uploadedFileUrl]);

  const handleFileSelect = (event) => {
    const data = event.target.files[0];

    const reader = new FileReader();

    if (data.type === 'application/pdf') {
      seIsPdf(true);
      try {
        reader.readAsDataURL(data);
        reader.onload = () => {
          const theBlob = reader.result;
          const blob = Buffer.from(
            theBlob.replace(/^data:application\/\w+;base64,/, ''),
            'base64',
          );

          setFileName(`doc${randomstring.generate(6)}${data.name}`);
          setFileType(data.type);
          setFile(data, blob);
        };
      } catch (error) {
        console.log(error);
      }
    } else {
      seIsPdf(false);
      // eslint-disable-next-line no-new
      new Compressor(data, {
        quality: 0.6,
        success(result) {
          reader.readAsDataURL(result);
          reader.onload = function () {
            const theBlob = reader.result;
            // eslint-disable-next-line no-buffer-constructor
            const blob = new Buffer(
              theBlob.replace(/^data:image\/\w+;base64,/, ''),
              'base64',
            );

            setFileName(`${randomstring.generate(6)}${result.name}`);
            setFileType(result.type);
            setFile(result, blob);
          };
        },
        error(err) {
          console.log(err.message);
        },
      });
    }
  };

  const handleFileRemove = (index)  => {
    setUploadedUrls(uploadedUrls.filter((_, idx ) => (index !== idx)))
    // eslint-disable-next-line no-param-reassign
    values.historyFile = [...uploadedUrls.filter((_, idx ) => (index !== idx))]
  }

  return (
    <>
      <Wrapper>
        <div className="file-wrapper p-3">
          <input
            disabled={isUploading}
            className="file-input"
            type="file"
            name="resume"
            onChange={(event) => handleFileSelect(event)}
          />
          {isUploading ? (
            <div className="loading">
              <Loading />
            </div>
          ) : (
            <div className="columns is-vcentered is-mobile">
              <div className="column">
                <SvgIcon
                  viewBox="0 0 89 79"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M33.5447 31.6765C36.9216 31.6765 39.6592 28.939 39.6592 25.562C39.6592 22.1851 36.9216 19.4475 33.5447 19.4475C30.1677 19.4475 27.4302 22.1851 27.4302 25.562C27.4302 28.939 30.1677 31.6765 33.5447 31.6765Z"
                    fill="#757575"
                  />
                  <path
                    d="M83.7347 48.0668C80.8473 45.3492 77.1956 43.5658 73.2042 43.0563V11.9742C73.2042 8.66221 71.8454 5.68989 69.7223 3.48187C67.5143 1.27386 64.542 0 61.23 0H11.9742C8.66221 0 5.68989 1.35878 3.48187 3.48187C1.27385 5.68989 0 8.66221 0 11.9742V51.124V54.7758V62.6737C0 65.9857 1.35878 68.958 3.48187 71.166C5.68989 73.374 8.66221 74.6479 11.9742 74.6479H59.6164C62.7586 77.1956 66.6651 78.8092 70.9962 78.8092C76.0067 78.8092 80.5076 76.771 83.7347 73.5439C86.9618 70.3168 89 65.8158 89 60.8053C89 55.7948 86.9618 51.2939 83.7347 48.0668ZM4.50095 11.9742C4.50095 9.93607 5.35019 8.06775 6.70897 6.79389C8.06775 5.43511 9.93607 4.58588 11.9742 4.58588H61.23C63.2681 4.58588 65.1365 5.43511 66.4952 6.79389C67.854 8.15267 68.7032 10.021 68.7032 12.0592V38.5553L56.1345 25.9866C55.2853 25.1374 53.8416 25.0525 52.9074 25.9866L33.9695 45.0095L21.146 32.1011C20.2968 31.2519 18.8531 31.167 17.9189 32.1011L4.50095 45.6889V11.9742ZM11.8893 70.3168V70.1469C9.85114 70.1469 7.98282 69.2977 6.62405 67.9389C5.35019 66.5801 4.50095 64.7118 4.50095 62.6737V54.7758V52.1431L19.5324 37.0267L32.3559 49.8502C33.2052 50.6994 34.6489 50.6994 35.583 49.8502L54.521 30.8273L66.9198 43.3111C66.6651 43.396 66.4103 43.4809 66.1555 43.5658C65.8158 43.6508 65.4761 43.7357 65.0515 43.9055C64.7118 43.9905 64.3721 44.1603 64.0324 44.2452C63.7777 44.3302 63.6078 44.4151 63.3531 44.5849C63.0134 44.7548 62.7586 44.8397 62.5038 45.0095C62.0792 45.2643 61.6546 45.5191 61.23 45.7739C60.9752 45.9437 60.8053 46.0286 60.5506 46.1985C60.3807 46.2834 60.2958 46.3683 60.126 46.4532C59.3616 46.9628 58.6823 47.5573 58.0878 48.2366C54.8607 51.4637 52.8225 55.9647 52.8225 60.9752C52.8225 62.249 52.9924 63.438 53.2471 64.7118C53.3321 65.0515 53.417 65.3063 53.5019 65.646C53.7567 66.4952 54.0114 67.3445 54.3511 68.1937V68.2786C54.6908 68.958 55.0305 69.7223 55.4552 70.3168H11.8893ZM80.4227 70.3168C77.9599 72.7796 74.6479 74.2233 70.9113 74.2233C67.3445 74.2233 64.0324 72.7796 61.6546 70.4866C61.3149 70.1469 60.9752 69.7223 60.6355 69.3826C60.3807 69.1279 60.126 68.7882 59.8712 68.5334C59.5315 68.1088 59.2767 67.5992 59.0219 67.0897C58.8521 66.75 58.6823 66.4952 58.5124 66.1555C58.3426 65.7309 58.1727 65.2214 58.0878 64.7118C58.0029 64.3721 57.833 63.9475 57.7481 63.6078C57.5782 62.7586 57.4933 61.8244 57.4933 60.8903C57.4933 57.1536 59.0219 53.8416 61.3998 51.3788C63.7777 48.916 67.1746 47.4723 70.9113 47.4723C74.6479 47.4723 77.9599 49.001 80.4227 51.3788C82.8855 53.8416 84.3292 57.1536 84.3292 60.8903C84.3292 64.542 82.8006 67.854 80.4227 70.3168Z"
                    fill="#757575"
                  />
                  <path
                    d="M72.5248 51.7186C72.355 51.5487 72.1002 51.3789 71.7605 51.209C71.5057 51.1241 71.2509 51.0392 70.9962 51.0392C70.9112 51.0392 70.9112 51.0392 70.9112 51.0392C70.8263 51.0392 70.8263 51.0392 70.8263 51.0392C70.5716 51.0392 70.3168 51.1241 70.062 51.209C69.8072 51.294 69.5525 51.4638 69.2977 51.7186L64.0324 56.9838C63.1832 57.8331 63.1832 59.2768 64.0324 60.2109C64.8817 61.0602 66.3254 61.0602 67.2595 60.2109L68.6183 58.8522V68.1938C68.6183 69.4676 69.6374 70.4867 70.9112 70.4867C72.1851 70.4867 73.2042 69.4676 73.2042 68.1938V58.8522L74.563 60.2109C75.4122 61.0602 76.8559 61.0602 77.7901 60.2109C78.6393 59.3617 78.6393 57.918 77.7901 56.9838L72.5248 51.7186Z"
                    fill="#757575"
                  />
                </SvgIcon>
              </div>
              <div className="column">
                <h1>{placeholder}</h1>
              </div>
            </div>
          )}
        </div>
      </Wrapper>
      {uploadedUrls && uploadedUrls.length > 0 && (
        <ModalBoxWrapper className="box mt-3">
          <div className="columns is-multiline">
            {uploadedUrls.map((url, index) => {
              const name = url.split('/').at(-1);
              const fileType = name.split('.').at(-1);
              return (
                <div
                  className="column is-4  mb-2 "
                  key={randomstring.generate(6)}
                >
                  <span onClick={() => handleFileRemove(index)} className='has-text-danger'>X</span>
                  {isPdf || fileType === "pdf" ? (
                    <Link target="_blank" to={{pathname: url}} > {`${index + 1} PDF: ${name}`} </Link>
                    
                  ) : (
                    <ModalImage small={url} large={url} alt="RD-glazing" />
                  )}
                </div>
              );
            })}
          </div>
        </ModalBoxWrapper>
      )}
    </>
  );
};

export default UploadImageInput;
